import Prando from "prando";
// Deterministic random number generator for chart storybook seeding
const rng = new Prando("HelloWorld");
export default () => rng.next();
